import Persist from '@services/persist'
import { getUserHash } from '@misc/user-hash'
import { CurrentEntityPersist, Entity, Kind, Type } from '@loctypes'

export const persistInitials = (entity: Entity): void => {
  const [kind, type] = entity.split('.') as [Kind, Type]

  // сохраняем текущий clientKey для дальнейшего доступа
  Persist.cookie.set<string>('userHash', getUserHash())
  Persist.memory.set<CurrentEntityPersist>('widgetType', { entity, kind, type })
}
